import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9ff7bb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-info" }
const _hoisted_2 = { class: "main-info" }
const _hoisted_3 = { class: "name-checkbox-wrap" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = {
  key: 0,
  class: "check-wrap nongfu-checkbox-wrap"
}
const _hoisted_6 = {
  key: 1,
  class: "custom-wrap"
}
const _hoisted_7 = { class: "infos" }
const _hoisted_8 = { class: "active-time-line" }
const _hoisted_9 = {
  key: 0,
  class: "tips-item"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "equity-item"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "8",
    r: "6",
    fill: "#00C378"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.96128 8.76309L6.0646 8.08665C6.04206 8.06964 6.03079 8.06114 6.02058 8.0542C5.82972 7.92449 5.57489 7.94224 5.40387 8.09716C5.39471 8.10545 5.38473 8.11543 5.36476 8.1354C5.34211 8.15805 5.33079 8.16937 5.32174 8.17946C5.15132 8.36943 5.15132 8.65726 5.32174 8.84723C5.33079 8.85732 5.34211 8.86864 5.36476 8.89129L6.65348 10.18C6.84862 10.3752 7.16501 10.3752 7.36015 10.18L10.6957 6.84448C10.7058 6.83435 10.7109 6.82928 10.7151 6.82489C10.899 6.63178 10.899 6.32825 10.7151 6.13513C10.7109 6.13074 10.7058 6.12568 10.6957 6.11555C10.6861 6.10598 10.6813 6.10119 10.6771 6.09718C10.4927 5.92111 10.2053 5.91206 10.0101 6.07617C10.0057 6.07991 10.0006 6.08438 9.99042 6.09333L6.96128 8.76309Z",
    fill: "white"
  })
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "进阶版立享 9 折优惠", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

import { Checkbox } from 'vant'
import { useWatchPropsItem } from '@/compositions/useWatch'
import { JijiaDeviceCardInfoListItem } from '@/types/insurance'
import {
  withDefaults,
  computed,
  ref,
  onMounted,
  Ref,
  nextTick,
  onUnmounted,
} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'device-card-info',
  props: {
    data: { default: () => ({
      headInfo: {
        name: '',
        img: '',
        sn: '',
        model: '',
        activeTime: '',
      },
      checked: false,
      sn: '555',
    }) },
    round: { type: Boolean, default: false },
    imgSize: { default: 48 }
  },
  emits: ['checkClick'],
  setup(__props: any, { emit: emits }) {

const props = __props as { data: JijiaDeviceCardInfoListItem, round: boolean, imgSize: number };



const useCheckbox = computed(() => !!props.data.useCheckbox)
const useCustom = computed(() => !!props.data.useCustom)
const snLine: Ref<HTMLDivElement | null> = ref(null)
const isNarrow = ref(false)
const headInfo = computed(() => {
  return props.data.headInfo
})
const checked = ref(props.data.checked)
const imgStyle = computed(() => {
  return `background-image: url(${props.data.headInfo.img});width: ${props.imgSize}px;height: ${props.imgSize}px`
})
const getWrapClass = computed(() => {
  const arr = []
  if (props.round) {
    arr.push('card-round')
    if (checked.value) {
      arr.push('card-round-active')
    }
  }
  return arr.join(' ')
})
useWatchPropsItem(props, 'data', () => {
  console.log('2', 2)
  if (props.data.checked !== checked.value) {
    checked.value = props.data.checked
  }
})
function clickHandle() {
  emits('checkClick', props.data)
}
function wrapClickHandle() {
  if (useCheckbox.value) {
    clickHandle()
  }
}
function resizeHandle() {
  nextTick(() => {
    if (snLine.value) {
      const height = snLine.value.getBoundingClientRect().height
      isNarrow.value = height >= 40
    }
  })
}
onMounted(() => {
  resizeHandle()
  window.addEventListener('resize', resizeHandle)
})
onUnmounted(() => {
  window.removeEventListener('resize', resizeHandle)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-wrap", _unref(getWrapClass)]),
    onClick: wrapClickHandle
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["img", !_unref(headInfo).img ? 'no-image' : '']),
        style: _normalizeStyle(_unref(imgStyle))
      }, null, 6),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(headInfo).name), 1),
          (_unref(useCheckbox))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_unref(Checkbox), {
                  modelValue: __props.data.checked,
                  onClick: _withModifiers(clickHandle, ["stop"]),
                  "icon-size": "20px"
                }, null, 8, ["modelValue", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (_unref(useCustom))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "customRight", { data: __props.data })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["sn-model-line", isNarrow.value ? 'narrow-sn-model-line' : '']),
            ref_key: "snLine",
            ref: snLine
          }, [
            _createElementVNode("div", null, "SN：" + _toDisplayString(_unref(headInfo).sn), 1),
            _createElementVNode("div", null, "型号：" + _toDisplayString(_unref(headInfo).model), 1)
          ], 2),
          _createElementVNode("div", _hoisted_8, "激活: " + _toDisplayString(_unref(headInfo).activeTime), 1)
        ])
      ])
    ]),
    (__props.data.tips)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", null, _toDisplayString(__props.data.tips), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.data.hasEquity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
      : _createCommentVNode("", true)
  ], 2))
}
}

})